import { connect } from "react-redux";
import { DateTime as Luxon, Interval } from "luxon";

import {
    gameLoaded,
    getGameById,
    getGameLink,
    getGamePaymentMethodLabel,
    getIsOrganizer,
    getIsPaySuccess,
    getIsTrainer,
} from "domain/Game/selectors";
import { recall, updateGameData } from "domain/Game/actions";
import Component from "./Component";
import { isLoggedIn } from "domain/Auth/selectors";
import {
    getCityById,
    getGameTypeById,
    getGameTypeImg,
    getGenderByCode,
    getLevelById,
    getCurrency,
} from "domain/Directories/selectors";
import { getProfile, getUserId } from "domain/User/selectors";
import { withRouter } from "react-router-dom";
import { setViewed } from "domain/Notifications/actions";
import { isMobile, isDesktop, isTablet } from "domain/Version/selectors";

const mapStateToProps = (state, { gameId }) => {
    if (!gameLoaded(state, gameId)) {
        return { shouldLoad: true };
    }

    const userId = getUserId(state);
    const game = getGameById(state, gameId);

    const { type_id, players_gender, starts_at, duration, level_id } = game;

    const startDateTime = Luxon.fromSQL(starts_at);
    const gameInterval = Interval.fromDateTimes(
        startDateTime,
        startDateTime.plus({ minutes: duration })
    );
    const now = Luxon.local();

    return {
        ...game,
        inProgress: gameInterval.contains(now),
        isLoggedIn: isLoggedIn(state),
        isOrganizer: getIsOrganizer(state, gameId, userId),
        isTrainer: getIsTrainer(state, gameId, userId),
        gameType: getGameTypeById(state, type_id),
        genderName: getGenderByCode(players_gender),
        gameTypeImg: getGameTypeImg(state, type_id),
        level: getLevelById(state, level_id),
        gameLink: getGameLink({ state, gameId }),
        city: getCityById(state, game?.playground?.city_id),
        isMobile: isMobile(state),
        isTablet: isTablet(state),
        isDesktop: isDesktop(state),
        profile: getProfile(state),
        currency: getCurrency(state),
        paymentMethod: getGamePaymentMethodLabel(state, gameId),
        isPaySuccess: getIsPaySuccess(state, gameId),
    };
};

const mapDispatchToProps = {
    recall,
    setViewed,
    updateGameData,
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Component)
);
